import { useEffect } from 'react';

export function useExperimentBodyClass(experimentKey: string, userVariant: string | null) {
    useEffect(() => {
        const body = document.querySelector('body');
        const className = `${experimentKey}-${userVariant}`;

        if (!body?.classList.contains(className)) {
            body?.classList.add(className);
        }

        return () => {
            body?.classList.remove(className);
        };
    }, [experimentKey, userVariant]);
}
